import * as React from "react";
import {DynamicDialog, DynamicDialogState} from "shared/controls/Dialogs/core/DynamicDialog";
import {DialogProps} from "shared/controls/Dialogs/core/Dialog";

export class LicenseRequired extends DynamicDialog<LicenseIsRequiredProps,LicenseIsRequiredState> {
    static defaultProps: Partial<LicenseIsRequiredProps> = {};

    constructor(props: LicenseIsRequiredProps) {
        super(props);
        this.state = {
            IsOpen:true,
            IsBusy:false
        };
    }

    GetAdditionalProperties(): DialogProps {
        return {
            Title:"Full version required",
            EnableApply:true,
            EnableCancel:true,
            CancelTitle:'Close',
            class:'LicenseRequired',
            ApplyTitle:'Get Full Version',
            OnApply:()=>{window.open(this.props.URL)}
        };
    }

    SubRenderer(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return this.props.Message
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface LicenseIsRequiredProps {
    Message:any;
    URL:string;
}

interface LicenseIsRequiredState extends DynamicDialogState{

}

//#endregion "My Region"